<template>
  <div class="header-page">
    <div class="head-item">
      <div style="padding: 0px 15px 0px 0px;" @click="toggleClick">
        <svg
          :class="{'is-active': isCollapse}"
          class="hamburger"
          viewBox="0 0 1024 1024"
          xmlns="http://www.w3.org/2000/svg"
          width="64"
          height="64">
          <path d="M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z" />
        </svg>
      </div>
      <!-- <div class="icon"></div> -->
      <div class="title">
        <span v-if="projectName" class="project-name">{{ projectName }}</span>
        <!-- sys-tenant users have no real hospital/department — show a localized
             system-admin label instead of the placeholder org name. -->
        <span v-if="user.tenantCode === 'sys'">{{ t('header.systemAdminConsole') }}</span>
        <template v-else>
          <span v-if="commomStore.hospitalName">
            {{ commomStore.masking ? t('header.maskedHospital') : commomStore.hospitalName }}
          </span>
          <span></span>
          <span v-if="commomStore.departmentName">-{{ commomStore.departmentName }}</span>
        </template>
      </div>
    </div>
    <div class="head-item">
      <!-- Language picker intentionally lives only on the login page and inside
           the Settings dialog (设置, via the avatar menu) — not in the top nav. -->
      <el-dropdown
        class="avatar-dropdown"
        popper-class="avatar-dropdown__popper"
        trigger="hover"
        :show-timeout="80"
        :hide-timeout="260"
        @command="handleCommand"
      >
        <el-avatar shape="square" :size="32" :src="user.avatar" />
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item
              v-if="user.tenantCode === 'sys'"
              command="changeTenant"
              style="color: darkred"
            >
              {{ t('header.switchTenant') }}
            </el-dropdown-item>
            <el-dropdown-item
              v-if="user.tenantCode === 'sys'"
              command="configForm"
              style="color: dodgerblue"
            >
              {{ t('header.configForm') }}
            </el-dropdown-item>
            <el-dropdown-item
              v-if="routePath !== '/person/project'"
              command="project"
            >
              {{ t('header.switchProject') }}
            </el-dropdown-item>
            <el-dropdown-item command="settings">{{ t('header.settings') }}</el-dropdown-item>
            <el-dropdown-item divided command="logout">{{ t('header.logout') }}</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <div class="user-name">{{ user.name }}</div>
    </div>
  </div>
  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-model="dialogVisible"
    :title="initPwd ? t('header.setPassword') : t('header.changePassword')"
    width="500"
    :closed="handleClose">
    <el-form :model="form" label-width="100px" ref="ruleFormRef" :rules="rules">
      <el-form-item :label="t('header.oldPassword')" prop="old" v-if="!initPwd">
        <el-input v-model="form.old" :placeholder="t('header.enterOldPassword')"/>
      </el-form-item>
      <el-form-item :label="initPwd ? t('header.setPassword') : t('header.newPassword')" prop="password">
        <el-input v-model="form.password" :placeholder="t('header.enterNewPassword')"/>
      </el-form-item>
      <el-form-item :label="t('header.confirmPassword')" prop="repassword">
        <el-input v-model="form.repassword" :placeholder="t('header.enterConfirmPassword')"/>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ t('common.cancel') }}</el-button>
        <el-button type="primary" @click="handleSubmit">
          {{ t('common.confirm') }}
        </el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    v-model="headDialogVisible"
    :title="t('header.avatarSettings')"
    width="400"
    :closed="handleClose">
    <el-upload
      class="avatar-uploader"
      :show-file-list="false"
      :action="url"
      :headers="imageupload()"
      :on-success="handleAvatarSuccess"
    >
      <img v-if="imageUrl" :src="imageUrl" class="avatar" />
      <el-icon v-else class="avatar-uploader-icon"><Plus /></el-icon>
    </el-upload>

    <template #footer>
      <div class="dialog-footer">
        <el-button @click="headDialogVisible = false">{{ t('common.cancel') }}</el-button>
        <el-button type="primary" @click="handleUploadHead">
          {{ t('common.confirm') }}
        </el-button>
      </div>
    </template>
  </el-dialog>

  <el-dialog
    v-model="settingsDialogVisible"
    :title="t('header.settings')"
    width="500"
    class="settings-dialog"
  >
    <div class="settings-list">
      <div class="settings-row">
        <div class="settings-row__text">
          <div class="settings-row__title">{{ t('locale.switcher') }}</div>
          <div class="settings-row__desc">{{ t('header.languageDesc') }}</div>
        </div>
        <el-select
          :model-value="currentLocale"
          style="width: 180px"
          @change="handleLocaleChange"
        >
          <el-option
            v-for="code in SUPPORTED_LOCALES"
            :key="code"
            :value="code"
            :label="t(`locale.${code}`)"
          />
        </el-select>
      </div>
      <div class="settings-row">
        <div class="settings-row__text">
          <div class="settings-row__title">
            {{ initPwd ? t('header.setPassword') : t('header.changePassword') }}
          </div>
          <div class="settings-row__desc">{{ t('header.changePasswordDesc') }}</div>
        </div>
        <el-button @click="openPasswordDialog">{{ t('header.modify') }}</el-button>
      </div>
      <div class="settings-row" v-if="tenant.tenantType === 'PERSONAL'">
        <div class="settings-row__text">
          <div class="settings-row__title">{{ t('header.avatarSettings') }}</div>
          <div class="settings-row__desc">{{ t('header.avatarSettingsDesc') }}</div>
        </div>
        <el-button @click="openAvatarDialog">{{ t('header.modify') }}</el-button>
      </div>
      <!-- Font theme picker temporarily hidden — the three current
           presets look too similar in practice. The setFontTheme /
           applyFontTheme plumbing in store/common.ts is intentionally
           left intact so we can re-enable the picker (with more
           distinct options) by flipping v-if back to true. Default
           remains "modern" via DEFAULT_FONT_THEME. -->
      <div v-if="false" class="settings-row settings-row--stacked">
        <div class="settings-row__text">
          <div class="settings-row__title">{{ t('header.fontTheme') }}</div>
          <div class="settings-row__desc">{{ t('header.fontThemeDesc') }}</div>
        </div>
        <div class="font-theme-picker">
          <button
            v-for="theme in fontThemeOptions"
            :key="theme.value"
            type="button"
            class="font-theme-card"
            :class="[
              `font-theme-card--${theme.value}`,
              { 'is-active': commomStore.fontTheme === theme.value },
            ]"
            @click="commomStore.setFontTheme(theme.value)"
          >
            <div class="font-theme-card__sample-en">Aa Clinical 2026</div>
            <div class="font-theme-card__sample-zh">中文医疗数据</div>
            <div class="font-theme-card__label">{{ t(theme.labelKey) }}</div>
          </button>
        </div>
      </div>
      <div class="settings-row">
        <div class="settings-row__text">
          <div class="settings-row__title">
            {{ t('header.compactMode') }}<span class="settings-row__beta">{{ t('header.betaSuffix') }}</span>
          </div>
          <div class="settings-row__desc">{{ t('header.compactModeDesc') }}</div>
        </div>
        <el-switch
          :model-value="commomStore.compactForm"
          @change="commomStore.toggleCompactForm()"
        />
      </div>
      <div class="settings-row">
        <div class="settings-row__text">
          <div class="settings-row__title">
            {{ t('header.darkMode') }}<span class="settings-row__beta">{{ t('header.betaSuffix') }}</span>
          </div>
          <div class="settings-row__desc">{{ t('header.darkModeDesc') }}</div>
        </div>
        <el-switch
          :model-value="commomStore.darkMode"
          @change="commomStore.toggleDarkMode()"
        />
      </div>
      <div class="settings-row" v-if="user.userType === 'SYS'">
        <div class="settings-row__text">
          <div class="settings-row__title">{{ t('header.dataMasking') }}</div>
          <div class="settings-row__desc">{{ t('header.dataMaskingDesc') }}</div>
        </div>
        <el-switch
          :model-value="commomStore.masking"
          @change="commomStore.toggleMasking()"
        />
      </div>
    </div>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="settingsDialogVisible = false">{{ t('common.close') }}</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { clearToken, imageUrlAndToken } from "@/utils/common"
import { useCommonStore, useUserStore, type FontTheme } from "@/store/common"
import { ElMessage } from "element-plus"
import { Plus } from '@element-plus/icons-vue'
import { useI18n } from "vue-i18n"
import {changePwd, changeTenant} from "@/api/login"
import { imageupload, getUrl2 } from "@/lib/Form/config/uploadConfig"
import { useProjectInfoStore } from "@/store/project"
import {
  getCurrentLocale,
  setCurrentLocale,
  SUPPORTED_LOCALES,
  type SupportedLocale,
} from "@/i18n"

const { t } = useI18n();

const currentLocale = computed<SupportedLocale>(() => getCurrentLocale());

const handleLocaleChange = (code: string) => {
  if ((SUPPORTED_LOCALES as readonly string[]).includes(code)) {
    setCurrentLocale(code as SupportedLocale, true);
  }
};

const projectInfoStore = useProjectInfoStore();
const route = useRoute();

const props = defineProps({
  showProect: {
    type: Boolean,
    default: false
  }
})

const routePath = computed(() => {
  return route.path;
});

const projectName = computed(() => {
  if (props.showProect) {
    return projectInfoStore.projectInfo.projectName;
  } else {
    return "";
  }
});

const url = getUrl2();
const commomStore = useCommonStore()
const userStore = useUserStore()
const isCollapse = defineModel();

const imageUrl = ref("");
const imageData = ref<any>({})

const router = useRouter();
const initPwd = ref(false);
const ruleFormRef = ref<any>(null)
const form = ref({
  old: "",
  password: "",
  repassword: ""
})

const rules = reactive({
  old: [
    { required: true, message: t('header.enterOldPassword'), trigger: 'blur' },
  ],
  password: [
    { required: true, message: t('header.enterNewPassword'), trigger: 'blur' },
  ],
  repassword: [
    { required: true, validator: (_rule: any, value: any, callback: any) => {
      if (value === '') {
        callback(new Error(t('header.enterConfirmPassword')))
      } else if (value !== form.value.password) {
        callback(new Error(t('header.passwordMismatch')))
      } else {
        callback()
      }
    }, trigger: 'blur' },
  ],
})

const tenant = ref<any>({ tenantType: "" })

const user = computed(() => {
  return userStore.userInfo
})

const dialogVisible = ref(false);
const headDialogVisible = ref(false);
const settingsDialogVisible = ref(false);

const fontThemeOptions: { value: FontTheme; labelKey: string }[] = [
  { value: "modern", labelKey: "header.fontThemeModern" },
  { value: "editorial", labelKey: "header.fontThemeEditorial" },
  { value: "friendly", labelKey: "header.fontThemeFriendly" },
];

const toggleClick = () => {
  isCollapse.value = !isCollapse.value;
}

const handleCommand = (name:string) => {
  switch (name) {
    case "logout":
      clearToken();
      router.push({
        path: "/login"
      })
      break;
    case "changeTenant":
      //confirm new tenant code
      const tenantCode =  window.prompt(t('header.tenantCodePrompt'))!.trim()
        if (tenantCode) {
          //change
        changeTenant({
          tenantCode: tenantCode
        }).then((res:any) => {
          ElMessage.success(t('common.opSuccess'))
            //刷新页面
            //location.reload();
        })
        }
      break;
    case "configForm":
      //confirm new tenant code
        if (!projectInfoStore.projectInfo.id) {
          projectInfoStore.fetchProjectInfo();
        }
        window.open('/manage/database?id='+projectInfoStore.projectInfo.id+'&name='+projectInfoStore.projectInfo.projectName)
      break;
    case "project":
        router.push({
          path: '/person/project'
        });
      break;
    case 'settings':
      settingsDialogVisible.value = true;
      break;
    default:
      break;
  }
}

// Both invoked from the Settings dialog; close it first so the
// follow-up dialog isn't visually stacked on top of the parent.
const openPasswordDialog = () => {
  settingsDialogVisible.value = false;
  dialogVisible.value = true;
}

const openAvatarDialog = () => {
  if (user.value.avatar) {
    imageUrl.value = user.value.avatar;
  }
  settingsDialogVisible.value = false;
  headDialogVisible.value = true;
}

const handleClose = () => {
  form.value.old = ""
  form.value.password = ""
  form.value.repassword = ""
  imageUrl.value = "";
  imageData.value = {};
}

const logout =() => {
  clearToken();
  router.replace({
    path: "/login"
  })
}
const handleSubmit = () => {
  if (!ruleFormRef.value) return
  ruleFormRef.value.validate((valid:boolean) => {
    if (valid) {
      changePwd({
        password: form.value.old,
        newPassword: form.value.password
      }).then(() => {
        if (initPwd.value) {
          ElMessage.success(t('header.passwordSetSuccess'));
        } else {
          ElMessage.success(t('header.passwordChangeSuccess'));
        }
        dialogVisible.value = false;
        logout();
      }).catch(() => {});
    } else {
      console.log('error submit!')
    }
  })
}


const handleAvatarSuccess = (res:any, file:any) => {
  const { previewUrl } = res!.data;
  imageData.value = res.data;
  imageUrl.value = imageUrlAndToken(previewUrl);
}

const handleUploadHead = () => {
  const currentUser = Object.assign({}, user.value);
  currentUser.avatar = imageData.value.previewUrl
  console.log("currentUser", currentUser);
  userStore.setInfo(currentUser, () => {
    headDialogVisible.value = false;
  })
}

onMounted(() => {
  userStore.getInfo((info:any) => {
    tenant.value = info.tenant|| {};
    initPwd.value = info.initPwd;
  });

  projectInfoStore.fetchProjectInfo();

})
</script>

<style scoped lang="scss">
.header-page {
  width: 100%;
  height: 48px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
  padding: 0px 16px;
  box-sizing: border-box;
  .head-item {
    display: flex;
    align-items: center;
    .icon {
      width: 18px;
      height: 18px;
      background-color: #D9D9D9;
    }
    .title {
      font-weight: bold;
      font-size: 16px;
      color: #303133;
      line-height: 24px;
      margin-left: 8px;
      .project-name {
        padding-right: 26px;
      }
    }
  }
  .user-name {
    font-weight: 400;
    font-size: 14px;
    color: #303133;
    padding-left: 8px;
    padding-right: 20px;
  }
  .hamburger {
    display: inline-block;
    vertical-align: middle;
    width: 20px;
    height: 20px;
  }
  .hamburger.is-active {
    transform: rotate(180deg);
  }
}
.el-avatar {
  --el-avatar-bg-color: transparent;
}
</style>
<style>
.el-dropdown-menu {
  --el-dropdown-menuItem-hover-color: #26C1BD;
}
.avatar-uploader .el-upload {
  min-height: 178px;
  border: 1px dashed var(--el-border-color);
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: var(--el-transition-duration-fast);
}

.avatar-uploader .el-upload:hover {
  border-color: var(--el-color-primary);
}

.el-icon.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  text-align: center;
}
.avatar-uploader .avatar {
  width: 179px;
}

.settings-dialog .settings-list {
  display: flex;
  flex-direction: column;
}
.settings-dialog .settings-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 4px;
  border-bottom: 1px solid var(--el-border-color-lighter, #ececec);
}
.settings-dialog .settings-row:last-child {
  border-bottom: none;
}
.settings-dialog .settings-row__text {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-right: 16px;
}
.settings-dialog .settings-row__title {
  font-size: 14px;
  font-weight: 500;
  color: var(--el-text-color-primary, #303133);
  line-height: 20px;
}
.settings-dialog .settings-row__desc {
  font-size: 12px;
  color: var(--el-text-color-secondary, #909399);
  line-height: 18px;
}
.settings-dialog .settings-row__beta {
  margin-left: 4px;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: var(--el-color-warning, #e6a23c);
  vertical-align: middle;
}

/* ---- Font theme picker ----
   Stacked layout: title row on top, three preview cards in a
   row below. Each card renders sample English + Chinese using
   the font stack of that theme so the user can compare
   visually before committing. Active card is teal-bordered. */
.settings-dialog .settings-row--stacked {
  flex-direction: column;
  align-items: stretch;
  gap: 12px;
}
.settings-dialog .font-theme-picker {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
}
.settings-dialog .font-theme-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 12px 10px;
  border: 1px solid var(--el-border-color-lighter, #e4e7ed);
  border-radius: 8px;
  background-color: var(--el-fill-color-blank, #fff);
  cursor: pointer;
  font: inherit;
  text-align: left;
  transition: border-color 0.18s ease, box-shadow 0.18s ease,
    transform 0.18s ease;
}
.settings-dialog .font-theme-card:hover {
  border-color: var(--el-color-primary, #26C1BD);
  transform: translateY(-1px);
}
.settings-dialog .font-theme-card.is-active {
  border-color: var(--el-color-primary, #26C1BD);
  box-shadow: 0 0 0 2px rgba(38, 193, 189, 0.18);
}
/* Per-card font preview — each card forces its own stack so
   the sample text actually looks different across the three
   options. Mirrors the theme definitions in style.scss. */
.settings-dialog .font-theme-card--modern {
  font-family:
    'Inter', -apple-system, BlinkMacSystemFont,
    'Segoe UI Variable', 'Segoe UI', system-ui,
    'PingFang SC', 'PingFang HK',
    'Microsoft YaHei UI', 'Microsoft YaHei',
    'Noto Sans SC', 'Source Han Sans SC',
    Roboto, sans-serif;
}
.settings-dialog .font-theme-card--editorial {
  font-family:
    'Source Sans 3', 'Source Sans Pro', -apple-system,
    BlinkMacSystemFont, 'Segoe UI', system-ui,
    'PingFang SC', 'Microsoft YaHei UI', 'Microsoft YaHei',
    'Source Han Sans SC', 'Noto Sans SC',
    sans-serif;
}
.settings-dialog .font-theme-card--friendly {
  font-family:
    'Manrope', -apple-system, BlinkMacSystemFont,
    'Segoe UI Variable', 'Segoe UI', system-ui,
    'PingFang SC',
    'Microsoft YaHei UI', 'Microsoft YaHei',
    'Noto Sans SC', sans-serif;
}
.settings-dialog .font-theme-card__sample-en {
  font-size: 16px;
  font-weight: 600;
  color: var(--el-text-color-primary, #303133);
  line-height: 1.2;
}
.settings-dialog .font-theme-card__sample-zh {
  font-size: 14px;
  font-weight: 500;
  color: var(--el-text-color-regular, #606266);
  line-height: 1.3;
}
.settings-dialog .font-theme-card__label {
  margin-top: 2px;
  font-size: 12px;
  font-weight: 500;
  color: var(--el-text-color-secondary, #909399);
  letter-spacing: 0.2px;
}
.settings-dialog .font-theme-card.is-active .font-theme-card__label {
  color: var(--el-color-primary, #26C1BD);
}

/* Dark-mode tweaks for the picker — html.dark-scoped to keep
   light mode identical (per dark-mode BETA invariant). */
html.dark .settings-dialog .font-theme-card {
  background-color: var(--imles-surface-2, #2a2a2a);
  border-color: var(--imles-border, #3a3a3a);
}
html.dark .settings-dialog .font-theme-card:hover {
  border-color: var(--imles-accent, #3dd8d1);
}
html.dark .settings-dialog .font-theme-card.is-active {
  border-color: var(--imles-accent, #3dd8d1);
  box-shadow: 0 0 0 2px rgba(61, 216, 209, 0.22);
}
html.dark .settings-dialog .font-theme-card__sample-en {
  color: var(--imles-text-primary, #f5f5f5);
}
html.dark .settings-dialog .font-theme-card__sample-zh {
  color: var(--imles-text-secondary, #c8c8c8);
}
html.dark .settings-dialog .font-theme-card.is-active .font-theme-card__label {
  color: var(--imles-accent, #3dd8d1);
}
</style>

<style lang="scss">
/* Avatar dropdown — forgiving hover gestures.
   A single dropdown-menu (no gaps between sub-wrappers) keeps the
   hover region contiguous; extra invisible padding above the popper
   bridges the small gap between the avatar trigger and the popper
   box so tracking off the trigger doesn't instantly close the menu. */
.avatar-dropdown__popper.el-popper {
  padding: 4px 0;
}
.avatar-dropdown__popper .el-dropdown-menu {
  padding: 4px 0;
  min-width: 140px;
}
.avatar-dropdown__popper .el-dropdown-menu__item {
  padding: 8px 20px;
  line-height: 1.4;
}
.avatar-dropdown__popper .el-dropdown-menu__item--divided {
  margin-top: 4px;
}
.avatar-dropdown__popper .el-dropdown-menu__item--divided::before {
  margin: 0;
}
</style>
